import React from 'react';
import './index.css';
import noDataFound from '../../../assets/images/icons/no-data-found.png';
import { Link, useNavigate } from 'react-router-dom';
import { Badge } from 'react-bootstrap';
import TotalBalance from '../../../pages/admin/ledger/total-balance';

function DataTable({ columns, data, partyLedgerRef }) {

  const navigate = useNavigate();

  return (
    <div className='ledger-party-datatable border rounded h-100'>
      <table ref={partyLedgerRef} className='table table-hover mb-0'>
        <thead className='table-head sticky-top'>
          <tr>
            {
              columns && columns.map((th_item, index) => {
                return (
                  <th key={index} className={index === 0 || index === 1 ? 'text-start bg-table-head' : 'text-center bg-table-head'}>{th_item}</th>
                )
              })
            }
          </tr>
        </thead>
        {
          data && data.length > 0 ?
            <tbody>
              {
                data && data.map((tb_items, index) => {

                  return (
                    <tr key={index} className={index === 0 ? 'cursor-pointer' : 'cursor-pointer border-top'} onClick={() => navigate(`/admin/ledger/${tb_items.id}`, { state: tb_items })}>
                      <td className='align-middle'>
                        {index + 1}
                      </td>
                      <td className="align-middle text-primary">
                        {tb_items.partyName}
                      </td>
                      <td className="align-middle text-center">
                        +91 {tb_items.phoneNumber}
                      </td>
                      <td className="align-middle text-center">
                        {tb_items.city}, {tb_items.state}
                      </td>
                      <td className="align-middle text-center">
                        <TotalBalance partyID={tb_items.id} />
                      </td>
                      <td className="align-middle text-center">
                        <Badge
                          pill
                          text='danger'
                          bg='fade alert alert-success px-3 py-1 fw-600'
                          className='mb-0'
                        >
                          Due
                        </Badge>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
            :
            <tbody>
              <tr>
                <td colSpan={7}>
                  <div className='no-data-found'>
                    <div className='text-center'>
                      <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                      <p className='mt-3'>No-Data Found</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
        }
      </table>
    </div>
  );
}

export default DataTable;